// # policies
import { SurveyPolicy } from '@/policies';
// # services
import { auth } from '@/services';

(function (angular) {
    'use strict';

    angular.module('app')
        .controller('surveysController', surveysController);

    surveysController.$inject = [
        '$rootScope',
        'Surveys',
        'SurveysApi',
        'surveysPayload',
        'alerts',
        'Helpers',
        '$scope'
    ];

    function surveysController(
        $rootScope,
        Surveys,
        SurveysApi,
        surveysPayload,
        alerts,
        Helpers,
        $scope
    ) {
        var vm = this;
        vm.limit = 9;
        const nowISO = window.moment().format(Helpers.isoFormat);

        console.log(SurveyPolicy.canCreate(auth.user()));
        // properties
        vm.permissionChecks = {
            canCreate: SurveyPolicy.canCreate(auth.user()),
        };
        vm.surveys = surveysPayload;
        vm.filters = {
            page: 1,
            starts_at_from: nowISO,
            voted_as: ($rootScope.thisUser ? $rootScope.thisUser.id : null),
            with: '',
            hide_if_child: true,
            type: 'survey',
        };
        vm.orderFilters = {
            ascending: {
                label: 'Ascending',
                sort: 'starts_at',
                order: 'asc',
                starts_at_from: nowISO,
                ends_at_from: null,
            },
            descending: {
                label: 'Descending',
                sort: 'starts_at',
                order: 'desc',
                starts_at_from: nowISO,
                ends_at_from: null,
            },
        };
        vm.selectedOrderFilter = vm.orderFilters.ascending;

        // methods
        vm.getSurveys = getSurveys;
        vm.orderSurveys = orderSurvey;
        vm.createSurvey = createSurvey;

        /**
         * Retrieves surveys from the API
         * @return {void}
         */
        function getSurveys() {
            vm.isLoading = true;

            Surveys.get(
                vm.filters,
                function handleGetSurveysResponse(response) {
                    vm.surveys = response;
                    vm.isLoading = false;
                },
                function handleGetSurveysError() {
                    vm.isLoading = false;
                }
            );
        }

        /**
         * Updates filters and refreshes the surveys.
         * Called by the order surveys select control.
         *
         * @return {void}
         */
        function orderSurvey() {
            angular.merge(vm.filters, vm.selectedOrderFilter);
            vm.filters.label = null;
            getSurveys();
        }

        $scope.loadMore = function() {
            var increamented = vm.limit + 3;
            vm.limit = increamented > vm.surveys.length ? vm.surveys.length : increamented;
        };

        /**
         * Calls create survey service, and appends new survey to the page
         * @return {void}
         */
        function createSurvey() {
            Surveys.manageSurvey();
        }
    }

}(angular));
